import { Component } from 'react'
import * as styles from 'components/features/pfm/HorizontalBarChart/HorizontalBarChart.css'
import * as cn from 'classnames'
import { CommonChartValues } from 'interfaces/chart'
import * as debounce from 'lodash/debounce'
import HorizontalBar from 'components/features/pfm/HorizontalBarChart/HorizontalBar'

export interface HorizontalBarChartProps {
  values: CommonChartValues
  options: {
    maxTotal?: number
    isCurrency?: boolean
    textLeft?: boolean
  }
}

type HorizontalBarChartState = {
  width: number | null
}

class HorizontalBarChart extends Component<HorizontalBarChartProps, HorizontalBarChartState> {

  state = {
    width: null,
  }

  private containerNode: HTMLElement | null = null

  render () {
    const { options, values } = this.props
    const { memberValue, peerValue, otherValue } = values
    const { isCurrency, textLeft, maxTotal } = options
    const maxValue = maxTotal || Math.max(memberValue, peerValue, otherValue)

    return (
      <figure
        className={ cn(styles.horizontalBarChart, { [styles.textLeft]: textLeft }) }
        ref={ (el) => this.containerNode = el }
      >
        <HorizontalBar
          isCurrency={ isCurrency }
          value={ memberValue }
          maxValue={ maxValue }
          maxWidth={ this.state.width }
          kind='member'
        />
        <HorizontalBar
          isCurrency={ isCurrency }
          value={ peerValue }
          maxValue={ maxValue }
          maxWidth={ this.state.width }
          kind='peers'
        />
        <HorizontalBar
          isCurrency={ isCurrency }
          value={ otherValue }
          maxValue={ maxValue }
          maxWidth={ this.state.width }
          kind='others'
        />
      </figure>
    )
  }

  componentDidMount () {
    this.setWidth()
    window.addEventListener('resize', this.handleResizeDebounced)
  }

  componentWillUnmount () {
    this.handleResizeDebounced.cancel()
    window.removeEventListener('resize', this.handleResizeDebounced)
  }

  private setWidth = () => {
    if (!this.containerNode) {
      return
    }

    this.setState({
      width: this.containerNode.getBoundingClientRect().width,
    })
  }

  private handleResizeDebounced = debounce(() => this.setWidth(), 50)
}

export default HorizontalBarChart
